import client from "./client";

export const fetchExecutionRules = async () => {
  const response = await client.get(`ea/autopilot/executions_by_rule_identifier/GA_ADGROUPKEYWORD_TOO_MANY_CLICKS?language_code=tr&current_page=1&records_per_page=4&order_by=2&sort_order=1`);
  return response.data;
}; 